import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { indicatorStyle } from './styles';
function Indicator({ size, variant }) {
    return (_jsx("span", { css: indicatorStyle({ size, variant }), "data-testid": "skill-tag-indicator" }));
}
export default Indicator;
